import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { completeLogin, login } from '../api/auth';

/** Cognito Hosted UI redirect target: exchanges the code for tokens and returns to where the user was. */
export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    completeLogin(location.search)
      .then((to) => navigate(to, { replace: true }))
      .catch((e: Error) => setError(e.message));
  }, [navigate]);
  return (
    <div className="empty">
      {error ? (
        <>
          <h3>Sign-in didn’t finish</h3>
          <p>{error}</p>
          <button type="button" className="btn primary" onClick={() => void login('/')}>
            Sign in again
          </button>
        </>
      ) : (
        <div className="spinner" style={{ margin: '0 auto' }} />
      )}
    </div>
  );
}
